// removed by extract-text-webpack-plugin
module.exports = {"marker":"CustomMarker-hashed__marker__129vs","icon":"CustomMarker-hashed__icon__3Sa-4"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilitiesMap/CustomMarker/CustomMarker-hashed.scss
// module id = 1171
// module chunks = 0